export default __webpack_public_path__ + "static/media/bg-login.00eb6b83.png";